import {useState} from 'react';

export function useInput(defaultValue = null, eventHandler = null) {
  const [value, setValue] = useState(defaultValue);

  const onChange = (event) => {
    setValue(event.target.value);
    if (eventHandler != null) {
      eventHandler(event);
    }
  }

  return [value, onChange];
}

